import utils from 'blue-utils';
import publicMutation from '$config/store/mutations';

//扩展公共的mutations
const mutations = utils.extend(publicMutation, {
  /*项目相关mutation*/
  // 地图选址地址
  setAddressValue(state, value) {
    state.selectAddressValue = value;
  }
});

export default mutations;